import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { router } from './router'
import { Toaster } from '@/components/ui/toaster'
import { AuthProvider } from './contexts/auth-context'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { AlertTriangle } from 'lucide-react'

function AppCrashFallback() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-white p-8">
      <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-red-50 text-red-500">
        <AlertTriangle className="w-7 h-7" />
      </div>
      <div className="text-center space-y-2 max-w-md">
        <p className="text-base font-semibold text-neutral-900">Something went wrong</p>
        <p className="text-sm text-neutral-500">
          An unexpected error occurred. Please refresh the page to try again.
        </p>
      </div>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-4 py-2 text-sm font-medium rounded-lg bg-neutral-900 text-white hover:bg-neutral-800 transition-colors"
      >
        Refresh page
      </button>
    </div>
  )
}

function App() {
  return (
    <ErrorBoundary fallback={<AppCrashFallback />}>
      <HelmetProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  )
}

export default App
